/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserGrantsDto } from '../../models/user-grants-dto';

export interface GetUserGrants$Params {
  projectId?: string | null;
}

export function getUserGrants(http: HttpClient, rootUrl: string, params?: GetUserGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGrantsDto>> {
  const rb = new RequestBuilder(rootUrl, getUserGrants.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserGrantsDto>;
    })
  );
}

getUserGrants.PATH = '/v0/users/grants';
